import "phaser";

import { BootScene } from "./scenes/BootScene";
import { PreloadScene } from "./scenes/PreloadScene";
import { BoardScene } from "./scenes/board/BoardScene";
import { SplashScene } from "./scenes/splash/SplashScene";
import { DevScene } from "./scenes/DevScene";
import { GameManager } from "./GameManager";
import { GameVars } from "./GameVars";
import { AudioManager } from "./AudioManager";

window.onload = () => {

    GameVars.setLayout(GameVars.inferIsLandscapeLayout());

    const gameConfig = {

        type: Phaser.AUTO,
        backgroundColor: "233c40",
        scale: {
            mode: Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_HORIZONTALLY,
            parent: "content",
            width: GameVars.gameWidth,
            height: GameVars.gameHeight
        },
        scene:  [
                    BootScene, 
                    PreloadScene,
                    SplashScene,
                    BoardScene,
                    DevScene
                ]
    };

    new Phaser.Game(gameConfig);

    window.focus();

    window.addEventListener("wheel", (event) => event.preventDefault(), {
        passive: false,
    });
      
    window.addEventListener("keydown", (event) => {
        if (["ArrowUp", "ArrowDown", " "].includes(event.key)) {
            event.preventDefault();
        }
    });

    window.addEventListener("resize", resize, false);
    window.addEventListener("blur", AudioManager.onBlur);
    window.addEventListener("focus", AudioManager.onFocus);

};

function resize(): void {

    GameManager.setGameSize();
}
